<script>
import UnfurledLink from "./unfurled_link.vue"
import Avatar from "@cmp/shared/avatar";
import EventBus from '../../event_bus';

export default {
  props: {
    anonymous: Boolean,
    content: String,
    hashid: String,
    author: String,
    author_avatar: String,
    created_at: Number,
    updated_at: Number,
    created_at_s: String,
    updated_at_s: String,
    comment_html: String,
    editable: Boolean,
    commentable: Boolean,
    cloudappLinks: Array
  },
  data() {
    return {
      hoverComment: false
    }
  },
  components: { UnfurledLink, Avatar },
  computed: {
    avatarUser: function(){
      return { attributes: { name: this.author }, links: { avatar_url: this.author_avatar } };
    }
  },
  methods: {
    destroyComment: function (commentID) {
      this.$store.dispatch('destroyComment', commentID);
    },
    updateCommentEditor: function () {
      // editor is always at the bottom, let's scroll down so users see they're editing
      // ideally edition is inline, this'll come later
      window.scrollTo(0,document.body.scrollHeight);
      EventBus.$emit("comment:edit", this.content, this.hashid);
    },
  },
}
</script>

<template>
  <div class="comment" @mouseover="hoverComment = hashid" @mouseleave="hoverComment = null">
    <div class="avatar">
      <avatar :user="avatarUser" size="sm" />
    </div>
    <div class="comment-content">
      <div class="comment-header">
        <div class="author">
          {{ anonymous ? 'Anonymous' : author }}
        </div>
        <div :class="hoverComment == hashid ? 'd-none' : 'timestamp'" :data-created-at="created_at" :data-updated-at="updated_at" v-if="editable">
          {{ created_at_s }}
          </div>
        <div class="timestamp" :data-created-at="created_at" :data-updated-at="updated_at" v-else>
            {{ created_at_s }}
        </div>
      </div>

      <div class="comment-body">
        <div class="comment-text" v-html="comment_html" v-linkified>
        </div>
        <span class="anonymous-name" v-if="anonymous">
          posted as {{ author }}
        </span>
      </div>

      <unfurled-link v-for="link in cloudappLinks" :link="link" v-bind:key="link" >
      </unfurled-link>
    </div>
    <div class="hover-actions" :class="{ active: hoverComment == hashid }" v-if="editable">
      <a v-if="commentable" href="javascript:;" v-on:click="updateCommentEditor();"><i class="fas fa-edit"></i></a>
      <a href="javascript:;" v-on:click="destroyComment(hashid);"><i class="fas fa-times-circle"></i></a>
    </div>
  </div>
</template>

<style scoped lang="scss">
@import '../../../packs/application.scss';

.comment {
  position: relative;
  margin-bottom: 1rem;
  border-radius: 0.3rem;
  display: flex;

  .d-none {
    display: none;
  }

  .hover-actions {
    background: #ffffff;
    padding-top: 0.6rem;
    padding-right: 1rem;
    width: 5rem;
    text-align: right;
    display: none;

    .fa-trash-alt {
      color: red;
    }
  }

  .active {
    display: block;

    a {
      &:link {
        color: $dark-gray-sf;
      }
      &:hover {
        color: $bright-blue;
      }
      &:active {
        color: $bright-blue;
      }
      &:visited {
        color: $dark-gray-sf;
      }
    }
  }

  .avatar {
    margin-top: .5rem;
  }

  .comment-content {
    flex-grow: 2;
    margin-left: 1rem;
    background-color: #ffffff;
    padding: 1rem;
    border-radius: 4px;
  }

  .comment-header {
    display: flex;
    justify-content: space-between;
    margin-bottom: .5rem;

    .author {
      height: 1rem;
      width: 7rem;
      font-family: SFPro;
      font-size: 0.75rem;
      font-weight: bold;
      font-stretch: normal;
      font-style: normal;
      line-height: 1.33;
      letter-spacing: normal;
      color: #4a4a4a;
      white-space: nowrap;
      text-overflow: ellipsis;
      overflow: hidden;

      &.recent::before {
        content: "\2022";
        color: $bright-blue;
        font-weight: bold;
      }
    }

    .timestamp {
      height: 1rem;
      font-family: SFPro;
      font-size: 0.75rem;
      font-weight: normal;
      font-stretch: normal;
      font-style: normal;
      line-height: 1.33;
      letter-spacing: normal;
      text-align: right;
      white-space: nowrap;
      color: rgba(74, 74, 74, 0.7);
    }
  }

  .comment-body {
    font-family: SFPro;
    font-size: 0.75rem;
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
    letter-spacing: normal;
    // color: rgba(44, 44, 46, 0.75);
    color: #4a4a4a;
    word-wrap: break-word;

    p {
      line-height: 1rem;
      font-size: 0.75rem;
    }

    .anonymous-name {
      font-size: .6rem;
      font-weight: bolder;
      color: rgba(74, 74, 74, 0.7);
    }

    .comment-text::v-deep p {
      margin-bottom: 0;
    }
  }
}
</style>